export const DEFAULT_QR_SVG =
  "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='160' height='160' viewBox='0 0 160 160'><rect width='160' height='160' fill='%23f8f9fa' stroke='%23dee2e6' stroke-width='2'/><rect x='20' y='20' width='35' height='35' fill='%23333'/><rect x='25' y='25' width='25' height='25' fill='%23fff'/><rect x='30' y='30' width='15' height='15' fill='%23333'/><rect x='105' y='20' width='35' height='35' fill='%23333'/><rect x='110' y='25' width='25' height='25' fill='%23fff'/><rect x='115' y='30' width='15' height='15' fill='%23333'/><rect x='20' y='105' width='35' height='35' fill='%23333'/><rect x='25' y='110' width='25' height='25' fill='%23fff'/><rect x='30' y='115' width='15' height='15' fill='%23333'/><rect x='70' y='25' width='15' height='15' fill='%23333'/><rect x='70' y='70' width='20' height='20' fill='%23333'/><rect x='105' y='70' width='15' height='15' fill='%23333'/><rect x='25' y='70' width='15' height='15' fill='%23333'/><rect x='70' y='115' width='15' height='15' fill='%23333'/><rect x='110' y='110' width='25' height='25' fill='%23333'/></svg>";

const getImageComponent = (model) => {
  if (!model) return null;
  const byTag = model.find('img');
  if (byTag && byTag.length) return byTag[0];

  const byClass = model.find('.totp-qr-image');
  if (byClass && byClass.length) return byClass[0];

  const byId = model.find('#secure-code');
  if (byId && byId.length) return byId[0];
  const search = (comp) => {
    if (!comp) return null;
    const tag = (comp.get('tagName') || '').toLowerCase();
    const attrs = comp.getAttributes ? comp.getAttributes() : {};
    if (tag === 'img' || attrs.id === 'secure-code') {
      return comp;
    }
    const children = comp.components ? comp.components() : null;
    if (children && children.models) {
      for (let i = 0; i < children.models.length; i++) {
        const found = search(children.models[i]);
        if (found) return found;
      }
    }
    return null;
  };
  return search(model);
};

export const RegisterTOTPButton = (bm, category, label, type) => {
  bm.add(type, {
    label: `<i class="webconnect-shield-fill-plus"></i><div>${label}</div>`,
    category: category,
    content: `<div data-gjs-type="${type}" id="register-totp" class="register-totp-container">
      <form class="form-container totp-register-form" id="totp-register-form" onsubmit="return false;">
        <p class="totp-instruction">Scan the QR Code in the Authenticator app then enter the code that you
  see in the app in the text field and click Submit.</p>
        <div class="totp-qr-wrapper mb-3">
          <img src="${DEFAULT_QR_SVG}" alt="QR Code" id="secure-code" class="totp-qr-image" style="width: 160px; height: 160px; object-fit: contain;" />
        </div>
        <div class="form-group mb-3">
          <label class="form-label" for="code">Security Code</label>
          <input type="text" class="form-control" placeholder="Security Code" name="code" id="code" required />
          <div class="text-danger" id="qr-code-error"></div>
        </div>
        <div class="form-group mb-3">
          <button type="submit" class="btn btn-primary" id="totp-submit-btn">Submit</button>
        </div>
      </form>
      <form class="form-container totp-reset-form" id="totp-reset-form" onsubmit="return false;" style="display: none;">
        <button type="submit" class="btn btn-danger" id="totp-reset-btn">Reset Authentication</button>
      </form>
    </div>`,
  });
};

export default (dc, label, type, config) => {
  const defaultType = dc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const { projectId, collections } = config;

  const isComponent = {
    isComponent(el) {
      if (el.getAttribute && el.getAttribute('data-gjs-type') == type) {
        return {
          type: type,
        };
      }
    },
  };

  const newModel = {
    defaults: {
      ...defaultModel.prototype.defaults,
      icon: '<i class="wb webconnect-shield-lock-fill"></i>',
      projectId,
      'data-hide-placeholder': '',
      'data-placeholder-img': '',
      traits: [
        {
          type: 'checkbox',
          name: 'data-hide-placeholder',
          label: 'Hide Image',
          valueTrue: 'true',
          valueFalse: '',
          changeProp: 1,
        },
        {
          type: 'text',
          name: 'data-placeholder-img',
          label: 'Placeholder Image',
          changeProp: 1,
        },
      ],
      script: function () {
        const projectId = '{[ projectId ]}';
        const totpOpts = { projectId };
        console.log('projectId', projectId);
        console.log('Going to load totp register', projectId);
        if (typeof loadTOTPComponent !== 'undefined') {
          loadTOTPComponent(this, totpOpts);
        }
      },
    },
    init() {
      this.listenTo(this, 'change:data-hide-placeholder', this.handleHidePlaceholder);
      this.listenTo(this, 'change:data-placeholder-img', this.handlePlaceholderImg);
    },
    handleHidePlaceholder() {
      const val = this.get('data-hide-placeholder');
      const isHide = val === 'true' || val === true;
      const attrs = { ...this.getAttributes() };
      if (isHide) {
        attrs['data-hide-placeholder'] = 'true';
      } else {
        delete attrs['data-hide-placeholder'];
      }
      this.setAttributes(attrs);

      const image = getImageComponent(this);
      if (image) {
        if (isHide) {
          image.addClass('d-none');
        } else {
          image.removeClass('d-none');
        }
      }
    },
    handlePlaceholderImg() {
      const placeholderImg = this.get('data-placeholder-img');
      const newSrc = placeholderImg || DEFAULT_QR_SVG;

      const attrs = { ...this.getAttributes() };
      if (placeholderImg) {
        attrs['data-placeholder-img'] = placeholderImg;
      } else {
        delete attrs['data-placeholder-img'];
      }
      this.setAttributes(attrs);

      const image = getImageComponent(this);
      if (image) {
        image.set('src', newSrc);
        const imgAttrs = { ...image.getAttributes(), src: newSrc };
        image.setAttributes(imgAttrs);
      }
    },
  };

  const extendModel = defaultModel.extend(newModel, isComponent);
  dc.addType(type, {
    model: extendModel,
    view: defaultView.extend({
      init() {
        this.listenTo(this.model, 'change:data-hide-placeholder', this.togglePlaceholder);
        this.listenTo(this.model, 'change:data-placeholder-img', this.updatePlaceholderImg);
      },
      onRender() {
        this.togglePlaceholder();
        this.updatePlaceholderImg();
      },
      togglePlaceholder() {
        const hide =
          this.model.get('data-hide-placeholder') === 'true' ||
          this.model.getAttributes()['data-hide-placeholder'] === 'true';
        const img = this.el ? this.el.querySelector('#secure-code') : null;
        if (img) {
          if (hide) {
            img.classList.add('d-none');
          } else {
            img.classList.remove('d-none');
          }
        }
      },
      updatePlaceholderImg() {
        const placeholderImg =
          this.model.get('data-placeholder-img') ||
          this.model.getAttributes()['data-placeholder-img'];
        const img = this.el ? this.el.querySelector('#secure-code') : null;
        if (img) {
          img.setAttribute('src', placeholderImg || DEFAULT_QR_SVG);
        }
      },
    }),
  });
};
